import rest from '@modules/rest'
import upload from '@modules/upload'
import request from '@graphql/middleware'
import * as get from '@graphql/queries'
import { getFileUrl, getUploadEndpoint } from '@modules/fileHelpers'
import { getEmployeeInfoSchema } from '@services/systemField'
import { DEPENDENTS_AREA } from '@convenia/common-organisms/SystemFields/content/consts'
import {
  mapDependent,
  mapDependentInput,
} from '@convenia/common-organisms/SystemFields/content/mappers/dependent'

export async function getOptions () {
  const [ err, data ] = await request(get.GetDependentOptions)
  const { relations, educationTypes } = data || {}

  const dependentRelations = relations
    .map(relation => ({ ...relation, id: +relation.id }))

  return [ err, { dependent: { dependentRelations, educationTypes } } ]
}

export const getDependents = async (params) => {
  try {
    const { employeeId, companyId } = params
    const { data = [] } = await rest.get(`/employees/proxy/companies/${companyId}/employees/${employeeId}/dependents/employee`)
    const dependents = data.map(dependent =>
      mapDependent(dependent, { getFileUrl, employeeId })
    )

    return [ null, dependents ]
  } catch (err) {
    return [ err, null ]
  }
}

export const createDependent = async (data, params) => {
  try {
    const { employeeId, companyId, schema } = params
    const body = mapDependentInput({ data, schema })

    const response = await rest.post(
      `/employees/proxy/companies/${companyId}/employees/${employeeId}/dependents/employee`,
      { body, headers: { bcv: true } }
    )

    const dependent = mapDependent(response?.data, { getFileUrl, employeeId })

    return [ null, dependent ]
  } catch (err) {
    return [ err, null ]
  }
}

export const updateDependent = async (data, params) => {
  try {
    const dependentId = data?.id
    const { employeeId, companyId, schema } = params
    const body = mapDependentInput({ data, schema, entityId: dependentId })

    await rest.put(
      `/employees/proxy/companies/${companyId}/employees/${employeeId}/dependents/${dependentId}/employee`,
      { body, headers: { bcv: true } }
    )

    return [ null, true ]
  } catch (err) {
    return [ err, null ]
  }
}

export const deleteDependent = async (data, params) => {
  try {
    const dependentId = data?.id
    const isCreating = typeof dependentId !== 'string'

    if (isCreating)
      return [ null, null ]

    const { employeeId, companyId } = params

    await rest.delete(`/employees/proxy/companies/${companyId}/employees/${employeeId}/dependents/${dependentId}/employee`)

    return [ null, null ]
  } catch (err) {
    return [ err, null ]
  }
}

export const uploadDependentFiles = async ({ id, files, employeeId }) => {
  try {
    const endpoint = getUploadEndpoint(employeeId, id, 'dependent')

    const data = await upload({ files, endpoint })

    return [ null, data || [] ]
  } catch (err) {
    return [ err, null ]
  }
}

export const mapSection = data => ({
  schema: data?.schema || {},
  values: data?.values || {},
})

export const mapCustomFields = data => ({
  dependent: mapSection(data.find(({ id }) => id === DEPENDENTS_AREA.DEPENDENTS)),
})

export const getCustomFields = async (params) => {
  const { employeeId, companyId } = params

  const [ err, data ] = await getEmployeeInfoSchema({
    employeeId,
    companyId,
    area: DEPENDENTS_AREA.LABEL
  })

  const customFields = mapCustomFields(data)

  return [ err, customFields ]
}
